











import { Component, Vue } from "vue-property-decorator";
import PatientSearch from "@/components/patientsearch/PatientSearch.vue";
import { Collections } from "@/mixins/firestoreMixin";

@Component({
  components: {
    PatientSearch
  }
})
export default class Hour24List extends Vue {
  // fire store 保存先コレクション
  private collection_name = Collections.SearchCondHour24List;

  // 利用者選択
  private clickSelect(patientId: number) {
    this.$router.push(`/patient/${patientId}/hour24/regist/0`);
  }
}
